export default "__VITE_ASSET__3688c89c__"